import { Box, Card, CardContent } from '@mui/material';
import React from 'react';
import FormFieldValues from '../../../Components/Custom/FormFieldValues';
import { isEmpty } from '../../../Util/UtilHelper';
import { VM_Colors } from '../../../Styles/VMStyles';
import { resolveVenueDetails } from '../../Feedback/FeedbackTemplate';

const formatPhone = (countryCode, phoneNo) => {
  const number = phoneNo ? String(phoneNo).trim() : '';
  if (!number) return '';
  const code = countryCode ? String(countryCode).trim() : '';
  const prefix = code ? (code.startsWith('+') ? code : `+${code}`) : '';
  return [prefix, number].filter(Boolean).join(' ');
};

const columnSx = {
  height: '100%',
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  backgroundColor: VM_Colors.white1,
  border: '1px solid #E4EAF2',
};

const Field = ({ title, value }) => {
  if (isEmpty(value) || !String(value).trim()) return null;
  return <FormFieldValues title={title} subtitle={value} textColor={VM_Colors.primary} />;
};

function InvoiceUserinfo({ enquiryState, venueState }) {
  const client = Array.isArray(enquiryState) ? enquiryState[0] : enquiryState;
  const venueSource = Array.isArray(venueState) ? venueState[0] : venueState;
  const venue = resolveVenueDetails(venueSource);

  if (isEmpty(client) && !venue) return null;

  return (
    <Box mt={2} sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 2,
          mb: 3,
          alignItems: 'stretch',
        }}
      >
        <Card sx={{ height: '100%', boxShadow: 'none', background: 'transparent' }}>
          <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
            <Box sx={columnSx}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.75 }}>
                <Field title="Name" value={client?.name} />
                <Field title="Mobile" value={formatPhone(client?.country_code, client?.phone_no)} />
                <Field title="Email" value={client?.email} />
                <Field title="Address" value={client?.address} />
              </Box>
            </Box>
          </CardContent>
        </Card>

        {venue && (
          <Card sx={{ height: '100%', boxShadow: 'none', background: 'transparent' }}>
            <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
              <Box sx={columnSx}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.75 }}>
                  <Field title="Venue name" value={venue.name} />
                  <Field title="Address" value={venue.address} />
                  <Field title="Email" value={venue.email} />
                  <Field title="Mobile" value={venue.phone} />
                </Box>
              </Box>
            </CardContent>
          </Card>
        )}
      </Box>
    </Box>
  );
}

export default InvoiceUserinfo;
